// extracted by mini-css-extract-plugin
export default {"h1":"vp_zWZfC","marginNone":"vp_Bve3u"};